import "./../PrivacyTerms.css";

const TermsAndConditions = () => {
  return (
    <div className="privacy container my-5 text-white">
      <h1 className="mb-4">Terms and Conditions</h1>
      <p><strong>Last Updated:</strong> July 9, 2024</p>
      <p>
        Thank you for using <strong>Gamer Club</strong> 
        These Terms and Conditions ("Terms") govern your access to and use of
        . By subscribing, you agree to these Terms. If you do
        not agree, you must refrain from using or subscribing to the Service.
      </p>

      <hr />

      <h2>1. About the Service</h2>
      <ul>
        <li>The Service provides  to operator subscribers.</li>
        <li>By subscribing, you will receive  SMS messages with tips, updates, entertainment content</li>
        <li>The Service is for individual use only and may not be shared or redistributed.</li>
      </ul>

      <h2>2. How to Subscribe</h2>
      <ul>
        <li>Enter your mobile number on the Service page and verify it using the PIN sent via SMS.</li>
        <li>You will receive a welcome message with details, including cost, frequency, and support info.</li>
      </ul>

      <h2>3. Pricing and Billing</h2>
      <ul>
        <li>Subscription fee:  300 IQD per day ,deducted from your operator balance.</li>
        <li>The subscription renews daily unless canceled.</li>
        <li>Cancel anytime by sending <strong>[0 ]</strong> to <strong>[2170]</strong>.</li>
      </ul>

      <h2>4. Eligibility</h2>
      <ul>
        <li>Available to operator subscribers aged 18 or older.</li>
        <li>Under 18s need parent/guardian consent.</li>
        <li>Requires SMS-compatible device on operator network.</li>
      </ul>

      <h2>5. Subscriber Responsibilities</h2>
      <ul>
        <li>Ensure enough balance for subscription charges.</li>
        <li>Provide accurate registration details and comply with Terms.</li>
        <li>Misuse may lead to immediate termination.</li>
      </ul>

      <h2>6. Cancellations and Refunds</h2>
      <ul>
        <li>Cancel anytime by sending <strong>[0 ]</strong> to <strong>[2170]</strong>.</li>
        <li>No refunds unless due to technical errors by operator or vendor.</li>
      </ul>

      <h2>7. Service Delivery and Limitations</h2>
      <ul>
        <li>Service is "as is" and may be interrupted due to technical issues or maintenance.</li>
        <li>No liability for delays or disruptions.</li>
      </ul>

      <h2>8. Modifications to the Service</h2>
      <ul>
        <li>operator and the vendor may modify or stop the Service anytime.</li>
        <li>Subscribers will be notified of major changes via SMS or other official means.</li>
      </ul>

      <h2>9. Privacy and Data Use</h2>
      <ul>
        <li>Your mobile number may be collected to deliver the Service.</li>
        <li>Data won’t be shared unless required for service delivery or by law.</li>
        <li>See Privacy Policy at: <a href="http://aciq.gamerclub.live/aciq-policy-and-privacy">Privacy Policy</a></li>
      </ul>

      <h2>10. Liability and Disclaimer</h2>
      <ul>
        <li>No responsibility for damage/loss except where required by law.</li>
        <li>If part of these Terms is unenforceable, the rest will still apply.</li>
      </ul>

      <h2>11. Contact and Support</h2>
      <p>For help with the Service, contact:</p>
      <p>Email: <a href="mailto:integration@worlinks.com"> integration@worlinks.com </a> </p>

      <h2>12. Ownership and Intellectual Property</h2>
      <p>
          Gamer Club is exclusively owned by World Link.
          The name “Gamer Club”, related trademarks, service marks, logos, and all content provided through the Service (including SMS messages, text, and any other materials) are the property of World Link and/or its licensors and are protected by applicable laws.
          Subscribers may not copy, reproduce, distribute, resell, sublicense, or otherwise exploit the Service or its content except for personal, non-commercial use.
      </p>

      <hr />

      <p className="mt-4">
        By subscribing to the Service, you confirm that you understand and accept these Terms and Conditions.
      </p>
    </div>
  );
};

export default TermsAndConditions;
